export type Period = 1 | 2 | 3 | 4;

export interface SyncConfig {
  /** Where each period's kickoff is in the video, in seconds. */
  kickoffs: Partial<Record<number, number>>;
  /** Match clock at each kickoff, in seconds (0, 45:00, …). */
  clockAt: Record<number, number>;
}

export interface MatchFormat {
  id: string;
  label: string;
  clockAt: Record<number, number>;
}

const min = (m: number) => m * 60;

export const MATCH_FORMATS: MatchFormat[] = [
  { id: 'adult', label: 'Adult · 2 × 45 min', clockAt: { 1: 0, 2: min(45), 3: min(90), 4: min(105) } },
  { id: 'youth40', label: 'Youth · 2 × 40 min', clockAt: { 1: 0, 2: min(40), 3: min(80), 4: min(95) } },
  { id: 'youth35', label: 'Youth · 2 × 35 min', clockAt: { 1: 0, 2: min(35), 3: min(70), 4: min(85) } },
  { id: 'youth30', label: 'Youth · 2 × 30 min', clockAt: { 1: 0, 2: min(30), 3: min(60), 4: min(75) } },
  { id: 'youth25', label: 'Youth · 2 × 25 min', clockAt: { 1: 0, 2: min(25), 3: min(50), 4: min(65) } },
];

export const PERIOD_LABELS: Record<number, string> = {
  1: '1st half',
  2: '2nd half',
  3: 'Extra time, 1st half',
  4: 'Extra time, 2nd half',
};

/**
 * Match clock to video time, the same formula as veo-highlights.mjs:
 * video time = kickoff in video + (match clock − clock at kickoff). Null while that period's kickoff isn't set.
 */
export function clockToVideo(period: number, clockSec: number, sync: SyncConfig): number | null {
  const kickoff = sync.kickoffs[period];
  if (kickoff === undefined || kickoff === null) return null;
  const at = sync.clockAt[period] ?? 0;
  return kickoff + (clockSec - at);
}

/** The periods a list needs kickoffs for, sorted. */
export function periodsNeeded(periods: number[]): number[] {
  return [...new Set(periods.filter((p) => p > 0))].sort((a, b) => a - b);
}
